module.exports = __webpack_public_path__ + "static/media/group.0dac8939.svg";